import { c as _c } from "react/compiler-runtime";
import { api } from "@shared-server/api";
import { type ChartConfig, ChartContainer, ChartTooltip, ChartTooltipContent } from "@shared-components/shadcn/chart";
import { CartesianGrid, XAxis, YAxis, BarChart, Tooltip, Legend, Bar } from "recharts";
import React from "react";
import { COLORS } from "./metric-utils";
import type { GranularityType } from "@shared-server/api/routers/queries/metrics/utils";
import { useDepartmentStackContext } from "@shared-components/department-stack-provider";
type ActiveUsersPerToolProps = {
  startDate: Date;
  endDate: Date;
  granularity: GranularityType;
};
const chartConfig: ChartConfig = {
  count: {
    label: "Active users per tool"
  }
};
export const ActiveUsersPerTool = props => {
  const $ = _c(34);
  const {
    parentDepartmentId
  } = useDepartmentStackContext();
  let t0;
  if ($[0] !== parentDepartmentId || $[1] !== props.endDate || $[2] !== props.granularity || $[3] !== props.startDate) {
    t0 = {
      dateStart: props.startDate,
      dateEnd: props.endDate,
      granularity: props.granularity,
      initialDepartmentId: parentDepartmentId
    };
    $[0] = parentDepartmentId;
    $[1] = props.endDate;
    $[2] = props.granularity;
    $[3] = props.startDate;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const {
    data
  } = api.coreMetrics.activeUsersPerTool.useQuery(t0);
  let t1;
  if ($[5] !== data) {
    t1 = Array.isArray(data?.overall) ? data.overall : [];
    $[5] = data;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const chartData = t1;
  let t2;
  if ($[7] !== data?.byDepartment) {
    t2 = data?.byDepartment || [];
    $[7] = data?.byDepartment;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const chartDataByDepartment = t2;
  let t3;
  if ($[9] !== chartData[0] || $[10] !== chartData.length) {
    t3 = chartData.length > 0 && chartData[0] ? Object.keys(chartData[0]).filter(_temp) : [];
    $[9] = chartData[0];
    $[10] = chartData.length;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const toolNames = t3;
  let t4;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <h2 className="mb-4">{"Active users per tool"}</h2>;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== chartData || $[14] !== toolNames) {
    t5 = chartData.length !== 0 && <div className="mt-8 flex h-[300px] w-full items-start"><div className="flex h-full flex-1 flex-col"><ChartContainer config={chartConfig} className="aspect-auto h-full flex-1"><BarChart data={chartData} margin={{
            top: 10,
            right: 30,
            left: 20,
            bottom: 10
          }} height={260}><CartesianGrid vertical={false} /><XAxis dataKey="date" tickLine={false} axisLine={false} tickMargin={8} fill="#006e96" minTickGap={32} /><YAxis yAxisId="count" interval={1} orientation="left" /><ChartTooltip content={<ChartTooltipContent className="w-[150px]" nameKey="date" labelFormatter={_temp2} />} />{toolNames.map(_temp3)}</BarChart></ChartContainer><div className="mt-2 flex h-[32px] flex-wrap items-center justify-center">{toolNames.map(_temp4)}</div></div></div>;
    $[13] = chartData;
    $[14] = toolNames;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== chartData.length) {
    t6 = chartData.length === 0 && <div className="text-gray-500">{"No data available for selected range."}</div>;
    $[16] = chartData.length;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <hr />;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="flex row gap-3 items-center mt-3"><h2 className="mb-4">{"Departments categorization"}</h2></div>;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t10;
  let t11;
  let t12;
  let t9;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      left: 35,
      top: 15,
      right: 15
    };
    t10 = <CartesianGrid />;
    t11 = <XAxis tickLine={false} axisLine={false} fill="#006e96" xAxisId="count" interval={0} type="number" />;
    t12 = <YAxis interval={0} orientation="left" dataKey="departmentName" type="category" />;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
    $[23] = t9;
  } else {
    t10 = $[20];
    t11 = $[21];
    t12 = $[22];
    t9 = $[23];
  }
  let t13;
  let t14;
  let t15;
  let t16;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <ChartTooltip wrapperStyle={{
      zIndex: 1
    }} content={<ChartTooltipContent className="max-w-[350px]" itemsContainerClassName="grid grid-cols-3 gap-2" />} />;
    t14 = <Tooltip />;
    t15 = <Legend />;
    t16 = <Bar key="tool" xAxisId="count" dataKey="toolUsage" name="count" fill={COLORS[0]} />;
    $[24] = t13;
    $[25] = t14;
    $[26] = t15;
    $[27] = t16;
  } else {
    t13 = $[24];
    t14 = $[25];
    t15 = $[26];
    t16 = $[27];
  }
  let t17;
  if ($[28] !== chartDataByDepartment) {
    t17 = <ChartContainer config={chartConfig} className="min-h-[150px] h-[775px] w-full"><BarChart accessibilityLayer={true} layout="vertical" data={chartDataByDepartment} margin={t9}>{t10}{t11}{t12}{t13}{t14}{t15}{t16}</BarChart></ChartContainer>;
    $[28] = chartDataByDepartment;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t17 || $[31] !== t5 || $[32] !== t6) {
    t18 = <>{t4}{t5}{t6}{t7}{t8}{t17}</>;
    $[30] = t17;
    $[31] = t5;
    $[32] = t6;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  return t18;
};
function _temp(key) {
  return key !== "date";
}
function _temp2(value) {
  return value;
}
function _temp3(tool, idx) {
  return <Bar stackId="tool" key={tool} yAxisId="count" type="monotone" dataKey={tool} name={tool} fill={COLORS[idx % COLORS.length]} />;
}
function _temp4(tool_0, idx_0) {
  return <span key={tool_0} className="mr-4 flex items-center text-sm"><span className="mr-1 inline-block h-3 w-3 rounded-full" style={{
      background: COLORS[idx_0 % COLORS.length]
    }} />{tool_0}</span>;
}